import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialCalendarAppointment: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.285 10.67h27.43v19.81h1.52V6.1h-1.52v3.04H2.285V6.1H.765v24.38h1.52zm25.91-6.1h1.52V6.1h-1.52ZM2.285 30.48h27.43V32H2.285Z\"/><path fill=\"currentColor\" d=\"M25.145 18.29h-3.05v1.52h-1.52v-1.52h-3.05v1.52h-1.52v3.05h1.52v1.52h1.52v1.52h1.53v1.53h1.52V25.9h1.52v-1.52h1.53v-1.52h1.52v-3.05h-1.52zm-1.53-4.58h1.53v1.53h-1.53Zm-6.09 0h1.52v1.53h-1.52Zm-6.1 12.19h1.53v1.53h-1.53Zm0-6.09h1.53v1.52h-1.53Zm0-6.1h1.53v1.53h-1.53ZM5.335 25.9h1.52v1.53h-1.52Zm0-6.09h1.52v1.52h-1.52Zm0-6.1h1.52v1.53h-1.52Zm3.05-9.14V6.1h1.52V4.57h12.19V6.1h1.52V4.57h4.58V3.05h-4.58V0h-1.52v3.05H9.905V0h-1.52v3.05h-4.57v1.52z\"/><path fill=\"currentColor\" d=\"M2.285 4.57h1.53V6.1h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialCalendarAppointment
